import { render } from "./MyDoctor.vue?vue&type=template&id=aaea188a&scoped=true&ts=true"
import script from "./MyDoctor.vue?vue&type=script&lang=ts"
export * from "./MyDoctor.vue?vue&type=script&lang=ts"

import "./MyDoctor.vue?vue&type=style&index=0&id=aaea188a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaea188a"]])

export default __exports__